/**
 * Les lectures du jeu, que la flèche de l'en-tête relance (le tirer-pour-rafraîchir des anciens
 * écrans). Leurs réponses arrivent dans `currentUser` (patron A) : rien ne se consomme ici, et les
 * tranches, lues aussi par la coquille, ne sont pas rendues au repos.
 *
 *  - « Mes quêtes » : `getSkillSets`, aussi à l'ouverture (`MySkillSetsTabScreen.js`).
 *  - « Classement » : `getUser` avec `refresh_rankings` (`RankingScreen.js`), rien à l'ouverture.
 *  - « Boutique » : `getUser` (`MyPetalsTabScreen.js`), rien à l'ouverture.
 */
import { useCallback, useEffect } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { authService } from "../../../../../../data/services/authService"
import { skillSetsService } from "../../../../../../data/services/skillSetsService"

export function useStudentQuestsData() {
    const dispatch = useDispatch()
    const refresh = useCallback(() => {
        dispatch(apiRequest(skillSetsService.getSkillSets) as never)
    }, [dispatch])

    useEffect(() => {
        refresh()
    }, [refresh])

    return { refresh }
}

export function useStudentRankingData() {
    const dispatch = useDispatch()
    const refresh = useCallback(() => {
        dispatch(apiRequest(authService.getUser, {}, {}, { refresh_rankings: true }) as never)
    }, [dispatch])
    return { refresh }
}

export function useStudentShopData() {
    const dispatch = useDispatch()
    const refresh = useCallback(() => {
        dispatch(apiRequest(authService.getUser) as never)
    }, [dispatch])
    return { refresh }
}
